import * as React from "react";
import { Classes, Icon } from "@blueprintjs/core";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
const InputMask = require("react-input-mask");
const BrV = require("br-validations");

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean
}

export default class CnpjCpfInput extends React.Component<Props, {}> {
  handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(evt.target.value.replace(/[-\/\.]/g, ""));
  };

  render() {
    let isCNPJ = true
    let isValid = false

    if (BrV.cpf.validate(this.props.value)) {

      isValid = true
      isCNPJ = false

    } else {

      if (BrV.cnpj.validate(this.props.value)) {

        isValid = true
        isCNPJ = true

      }

    }

    EmpresaStore.obs.isValid = isValid

    if (isValid) {

      EmpresaStore.obs.currentSteps = 3

    }

    return (
      <div className={Classes.INPUT_GROUP}>
        <InputMask
          mask={isCNPJ ? "99.999.999/9999-99" : "999.999.999-99"}
          className={Classes.INPUT + " cnpj-blur"}
          onChange={this.handleChange}
          value={this.props.value}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}
